/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  Form,
  InputGroup,
} from "react-bootstrap";

import Card from "components/Card/Card.jsx";

import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import {
  AddMedicationcategory,
  getupdatecategory,
  updateMedicationcategory,
} from "../../../Listfunction";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import { getApiErrorMessage } from "utils/getApiErrorMessage";

class editcategory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: "1",
      radioVariant: "1",
      wt_commision: "",
      wt_commisionError: null,
      medicationcategoryname: "",
      medicationcategorynameError: null,
      _notificationSystem: null,
      cardHidden: true,
      is_featured: "2",
      errormessages: [],
    };
    this.handleChange = this.handleChange.bind(this);
    this.onChange = this.onChange.bind(this);
    this.handlesubmit = this.handlesubmit.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
  }
  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Medication Category</b> - Updated Successfully .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  handleClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>something went wrong</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  componentDidMount() {
    var token = JSON.parse(localStorage.getItem("user"));
    var cat_id = JSON.parse(localStorage.getItem("cat_id"));
    // console.log(token);
    const obj = token.token;
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700,
    );
    // console.log(obj);
    getupdatecategory(cat_id, obj).then((response) => {
      var data = response.data;
      var is_featured = "";
      if (data.is_featured == "1") {
        is_featured = "1";
      } else if (data.is_featured == "0") {
        is_featured = "2";
      }

      this.setState({
        medicationcategoryname: data.category_name,
        wt_commision: data.wt_commision,
        is_featured: is_featured,
      });
    });
  }
  handleNetworkError(position, error) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          {/* <b>Network Error</b>. */}
          <b>{getApiErrorMessage(error)}</b>
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  handlesubmit = (e) => {
    this.setState({ errormessages: [] });
    let error = false;
    // console.log(this.state.medicationcategoryname.length);
    if (this.state.medicationcategoryname.length == 0) {
      error = true;
      this.setState({
        medicationcategorynameError: (
          <small className="text-danger">
            Medication Category Name is required.
          </small>
        ),
      });
    } else {
      this.setState({ medicationcategorynameError: null });
    }
    /*
    if (this.state.wt_commision.length == 0) {
      error = true;
      this.setState({
        wt_commisionError: (
          <small className="text-danger">Wt-commision is required..</small>
        ),
      });
    } else {
      this.setState({ wt_commisionError: null });
    } 
    */
    if (!error) {
      var token = JSON.parse(localStorage.getItem("user"));
      // console.log(token.token);
      var cat_id = JSON.parse(localStorage.getItem("cat_id"));
      const obj = token.token;
      var is_featured = "";
      if (this.state.is_featured == "1") {
        is_featured = "1";
      } else if (this.state.is_featured == "2") {
        is_featured = "0";
      }

      //  return false;
      updateMedicationcategory(
        this.state.medicationcategoryname,
        this.state.wt_commision,
        cat_id,
        is_featured,
        obj,
      )
        .then((res) => {
          if (res.data.success === false) {
            const message = res.data.data;

            if (res.data.data.length != 0) {
              var ermessage = [];
              for (var key of Object.keys(res.data.data)) {
                var data = res.data.data[key];
                ermessage.push(data);
              }
              this.setState({ errormessages: ermessage });
              this.setState({
                medicationcategorynameError: (
                  <small className="text-danger">{message.category_name}</small>
                ),
              });
            } else {
              this.handleClick("bl");
            }
          } else if (res.data.success === true) {
            this.handleSuccess("bl");
          }

          // this.props.history.push('/admin/medication-category');
        })
        .catch((error) => {
          this.handleNetworkError("bl", error);
          console.log(error, "== error");
        });
    }
  };
  handleChange = (event) => {
    const target = event.target;
    this.setState({
      [target.name]: target.value,
    });
  };
  onChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };
  render() {
    const errormessages = this.state.errormessages;
    return (
      <div className="main-content">
        <Grid fluid>
          <NotificationSystem ref="notificationSystem" style={style} />
          <Row>
            <Col md={12}>
              <Card
                content={
                  <form>
                    {errormessages.length != 0 && (
                      <div className=" alert alert-danger">
                        {errormessages.map((data) => (
                          <React.Fragment>
                            <li>{data}</li>
                          </React.Fragment>
                        ))}
                      </div>
                    )}
                    <FormGroup>
                      <ControlLabel> Category Name</ControlLabel>
                      <FormControl
                        name="medicationcategoryname"
                        value={this.state.medicationcategoryname || ""}
                        onChange={(event) => {
                          this.setState({
                            medicationcategoryname: event.target.value,
                          });
                          event.target.value === ""
                            ? this.setState({
                                medicationcategorynameError: (
                                  <small className="text-danger">
                                    Medication Category Name is required.
                                  </small>
                                ),
                              })
                            : this.setState({
                                medicationcategorynameError: null,
                              });
                        }}
                        placeholder="Enter Medication Categoryname"
                        type="text"
                      />
                      {this.state.medicationcategorynameError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>WT_Commition</ControlLabel>
                      <FormControl
                        name="wt_commision"
                        value={this.state.wt_commision || ""}
                        onChange={(event) => {
                          this.setState({ wt_commision: event.target.value });
                        }}
                        placeholder="Enter WT_Commision"
                        type="text"
                      />
                      {this.state.wt_commisionError}
                    </FormGroup>
                    <FormGroup className="">
                      <ControlLabel>Is Featured ?</ControlLabel>
                      <Radio
                        number="7"
                        option="1"
                        name="is_featured"
                        onChange={this.onChange}
                        checked={this.state.is_featured === "1"}
                        label="Yes"
                      />
                      <Radio
                        number="8"
                        option="2"
                        name="is_featured"
                        onChange={this.onChange}
                        checked={this.state.is_featured === "2"}
                        label="No"
                      />
                    </FormGroup>
                    <Button onClick={this.handlesubmit} class="btn-color" fill>
                      Update
                    </Button>
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default editcategory;
